import type { HaulierCreatePayload } from "@/customTypings/haulier/Haulier";
import type { HaulierDeletedRestoreAvailableConflict } from "@/utils/haulier/haulierCreateConflict";
import {
    HAULIER_CREATE_CONFLICT,
    HaulierCreateConflictError,
    isHaulierDeletedRestoreAvailableConflict,
} from "@/utils/haulier/haulierCreateConflict";
import { createPayloadSpreadRestoreConfig } from "./createPayloadSpreadRestoreConfig";

export function createHaulierRestoreConfig<TDetail extends { id: string }>(options: {
    restoreDeletedWithCreateValues: (payload: HaulierCreatePayload & { id: string }) => Promise<TDetail>;
    onRestored: (detail: TDetail) => void;
}) {
    return createPayloadSpreadRestoreConfig<
        HaulierDeletedRestoreAvailableConflict,
        HaulierCreatePayload,
        HaulierCreatePayload & { id: string },
        TDetail,
        HaulierCreateConflictError
    >({
        ConflictErrorClass: HaulierCreateConflictError,
        isRestoreAvailable: isHaulierDeletedRestoreAvailableConflict,
        deletedRestoreAvailableCode: HAULIER_CREATE_CONFLICT.deletedRestoreAvailable,
        modalTitle: "Restore deleted Haulier?",
        modalBody: () =>
            "A deleted Haulier matching these details already exists. Restore it using the details you entered?",
        successLabel: (conflict) => conflict.existingName,
        restoreDeletedWithCreateValues: options.restoreDeletedWithCreateValues,
        onRestored: (detail) => options.onRestored(detail),
    });
}
